module.exports = __webpack_public_path__ + "img/logo_ebiodiv.c4e03b00.png";